import { useEffect } from "react";

export function useHashScrollWithOffset(selectorForHeader = "nav", extra = 16) {
  useEffect(() => {
    const getHeaderOffset = () => {
      const header = document.querySelector(selectorForHeader);
      return header ? header.offsetHeight : 0;
    };

    const scrollToId = (id) => {
      const el = document.getElementById(id);
      if (!el) return;

      const offset = getHeaderOffset() + extra; // compensa sticky + un respirito
      const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({ top: y, behavior: "smooth" });
    };

    const tryScroll = () => {
      const hash = decodeURIComponent(window.location.hash.replace("#", ""));
      if (!hash) return;

      let tries = 0;
      const maxTries = 12;

      const tick = () => {
        tries++;
        const el = document.getElementById(hash);
        // espera a que el elemento exista y tenga tamaño (evita layout shift por imágenes)
        if (el && el.getBoundingClientRect().height > 0) {
          scrollToId(hash);
        } else if (tries < maxTries) {
          requestAnimationFrame(tick);
        }
      };

      tick();
    };

    // al cargar y cuando cambia el hash (desde WP o desde el propio menú)
    if (window.location.hash) tryScroll();
    window.addEventListener("hashchange", tryScroll);
    window.addEventListener("load", tryScroll);

    return () => {
      window.removeEventListener("hashchange", tryScroll);
      window.removeEventListener("load", tryScroll);
    };
  }, [selectorForHeader, extra]);
}
